/*
 * @Author: 黄贺林
 * @Date: 2024-07-08 09:03:40
 * @LastEditTime: 2024-08-23 10:15:38
 * @Description: 引入对应国际化文件
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store'

import elCa from 'element-ui/lib/locale/lang/ca'
import elDe from 'element-ui/lib/locale/lang/de'
import elEn from 'element-ui/lib/locale/lang/en'
import elEs from 'element-ui/lib/locale/lang/es'
import elFr from 'element-ui/lib/locale/lang/fr'
import elHu from 'element-ui/lib/locale/lang/hu'
import elIt from 'element-ui/lib/locale/lang/it'
import elKo from 'element-ui/lib/locale/lang/ko'
import elLa from '@/lang/config/elLa' // element 没有拉丁语 自建
import elNl from 'element-ui/lib/locale/lang/nl'
import elPl from 'element-ui/lib/locale/lang/pl'
import elPt_BR from 'element-ui/lib/locale/lang/pt-br'
import elUa from 'element-ui/lib/locale/lang/ua'
import elRuRU from 'element-ui/lib/locale/lang/ru-RU'
import elSvSE from 'element-ui/lib/locale/lang/sv-SE'
import elTrTR from 'element-ui/lib/locale/lang/tr-TR'
import elZh_CN from 'element-ui/lib/locale/lang/zh-CN'
import elZh_TW from 'element-ui/lib/locale/lang/zh-TW'
import elJa from 'element-ui/lib/locale/lang/ja'
import elCsCZ from 'element-ui/lib/locale/lang/cs-CZ'


import ca from '@/lang/config/ca'
import de from '@/lang/config/de'
import en from '@/lang/config/en'
import es from '@/lang/config/es'
import fr from '@/lang/config/fr'
import hu from '@/lang/config/hu'
import it from '@/lang/config/it'
import ko from '@/lang/config/ko'
import la from '@/lang/config/la'
import nl from '@/lang/config/nl'
import pl from '@/lang/config/pl'
import ptBR from '@/lang/config/pt_BR'
import ua from '@/lang/config/ua'
import ru from '@/lang/config/ru'
import sv from '@/lang/config/sv'
import tr from '@/lang/config/tr'
import zhCN from '@/lang/config/zh_CN'
import zhTW from '@/lang/config/zh_TW'
import cs from '@/lang/config/cs'
import ja from '@/lang/config/ja'

Vue.use(VueI18n);

export const keys = {
    'ca_ES': Object.assign(ca, elCa),
    'de_DE': Object.assign(de, elDe),
    'en_GB': Object.assign(en, elEn),
    'es_ES': Object.assign(es, elEs),
    'fr_FR': Object.assign(fr, elFr),
    'hu_HU': Object.assign(hu, elHu),
    'it_IT': Object.assign(it, elIt),
    'ko_KR': Object.assign(ko, elKo),
    'la': Object.assign(la, elLa),
    'nl_NL': Object.assign(nl, elNl),
    'pl_PL': Object.assign(pl, elPl),
    'pt_BR': Object.assign(ptBR, elPt_BR),
    'ru_RU': Object.assign(ru, elRuRU),
    'sv_SE': Object.assign(sv, elSvSE),
    'tr_TR': Object.assign(tr, elTrTR),
    'uk_UA': Object.assign(ua, elUa),
    'zh_CN': Object.assign(zhCN, elZh_CN),
    'zh_TW': Object.assign(zhTW, elZh_TW),
    'cs_CZ': Object.assign(cs, elCsCZ),
    'ja_JP': Object.assign(ja, elJa),
}


let locale = localStorage.getItem('language') || 'zh_CN';

export const i18n = new VueI18n({
    locale,
    messages: keys,
    fallbackLocale: 'zh_CN'
}); 

